import { injectReducer } from 'REDUCER';
import createContainer from 'UTIL/createContainer';
import Utility from 'UTIL/utility';

const connectComponent = createContainer(
  ({ common }) => ({ common }), // mapStateToProps
  require('ACTION/common/apiGatewayAction').default, // mapActionCreators
);

export default {
  path: '/app/luckyApp',

  /* 布局基页 */
  getComponent(nextState, cb) {
    require.ensure(
      [],
      (require) => {
        // 立即注入 Reducer
        injectReducer(
          'common',
          require('REDUCER/common/apiGatewayReducer').default,
        );

          cb(null, connectComponent(require('../../../view/app/lucky/luckyApp').default));
      },
      'luckyApp',
    );
  },
  onEnter: () => {
    //Utility.setTitle('下载paypay')
  }
};



// WEBPACK FOOTER //
// ./src/route/app/lucky/luckyApp.js